import { render, staticRenderFns } from "./permissionList.vue?vue&type=template&id=115537a5&scoped=true"
import script from "./permissionList.vue?vue&type=script&lang=jsx"
export * from "./permissionList.vue?vue&type=script&lang=jsx"
import style0 from "./permissionList.vue?vue&type=style&index=0&id=115537a5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115537a5",
  null
  
)

export default component.exports